var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38807 6.24448C7.65884 6.34756 7.02191 7.03218 7.01576 7.03833C7.0066 7.04782 6.99626 7.05609 6.98499 7.06294C5.99422 7.70602 5.43576 7.21679 5.41268 7.18756C4.77884 6.61679 5.36038 5.65987 5.38499 5.61987C5.64463 5.18833 5.95903 4.79222 6.32038 4.44141H3.62961L2.46191 8.29371C2.47446 8.30067 2.48587 8.30949 2.49576 8.31987C4.30807 10.3691 6.71422 12.1876 7.66345 12.8737C7.76224 12.9468 7.88509 12.9796 8.00714 12.9655C8.12919 12.9514 8.24134 12.8915 8.3209 12.7979C8.40045 12.7042 8.44147 12.5839 8.43566 12.4612C8.42986 12.3384 8.37765 12.2225 8.28961 12.1368L6.98345 10.8306C6.9548 10.8018 6.93872 10.7628 6.93872 10.7222C6.93872 10.6815 6.9548 10.6425 6.98345 10.6137C6.99776 10.5993 7.01477 10.5878 7.03352 10.58C7.05227 10.5722 7.07237 10.5682 7.09268 10.5682C7.11299 10.5682 7.1331 10.5722 7.15185 10.58C7.1706 10.5878 7.18761 10.5993 7.20191 10.6137L7.8973 11.3091L8.51268 11.9245L8.82038 12.2399C8.93075 12.3474 9.07885 12.4074 9.23293 12.407C9.38701 12.4066 9.53482 12.3459 9.64467 12.2379C9.75452 12.1298 9.81768 11.983 9.82062 11.829C9.82356 11.6749 9.76603 11.5259 9.66038 11.4137L8.46191 10.1629L8.23422 9.92756C8.2198 9.91326 8.20836 9.89624 8.20055 9.8775C8.19274 9.85875 8.18872 9.83864 8.18872 9.81833C8.18872 9.79802 8.19274 9.77791 8.20055 9.75916C8.20836 9.74042 8.2198 9.7234 8.23422 9.7091C8.24852 9.69468 8.26554 9.68323 8.28429 9.67542C8.30304 9.66761 8.32314 9.66359 8.34345 9.66359C8.36376 9.66359 8.38387 9.66761 8.40262 9.67542C8.42137 9.68323 8.43838 9.69468 8.45268 9.7091L10.2019 11.5245C10.2866 11.6083 10.3938 11.6657 10.5106 11.6898C10.6273 11.7139 10.7485 11.7035 10.8594 11.66C10.9704 11.6165 11.0663 11.5417 11.1356 11.4448C11.2048 11.3478 11.2445 11.2328 11.2496 11.1137C11.2522 11.0298 11.237 10.9464 11.2052 10.8687C11.1734 10.791 11.1256 10.7209 11.065 10.6629L10.0158 9.64756L9.28499 8.93833C9.26872 8.92476 9.25543 8.90797 9.24596 8.88902C9.23648 8.87007 9.23102 8.84937 9.22991 8.82821C9.22881 8.80706 9.23209 8.7859 9.23954 8.76607C9.24699 8.74624 9.25846 8.72816 9.27323 8.71297C9.288 8.69777 9.30574 8.6858 9.32536 8.67778C9.34497 8.66977 9.36603 8.66589 9.38721 8.6664C9.40839 8.6669 9.42923 8.67177 9.44844 8.68071C9.46765 8.68964 9.48481 8.70245 9.49884 8.71833L11.5758 10.7291C11.6302 10.785 11.6955 10.8294 11.7675 10.8594C11.8396 10.8895 11.917 10.9047 11.9951 10.904C12.0732 10.9034 12.1503 10.8869 12.2218 10.8556C12.2934 10.8244 12.3579 10.779 12.4114 10.7221C12.4649 10.6653 12.5064 10.5982 12.5333 10.5249C12.5602 10.4515 12.572 10.3736 12.5679 10.2956C12.5639 10.2176 12.5441 10.1413 12.5097 10.0711C12.4754 10.001 12.4272 9.93856 12.3681 9.88756L8.38807 6.24448Z",
    fill: "url(#paint0_linear_133_63768)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15985 3.53854C2.36117 3.17947 1.49029 3.00992 0.615234 3.04315V9.077H1.55523C1.65556 9.07724 1.75323 9.04478 1.83345 8.98454C1.91368 8.9243 1.97209 8.83956 1.99985 8.74315L3.41216 4.09238C3.44444 3.98517 3.43664 3.86988 3.39023 3.76798C3.34381 3.66609 3.26193 3.58454 3.15985 3.53854Z",
    fill: "url(#paint1_linear_133_63768)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88632 3.83532C8.55455 3.69874 8.18383 3.69052 7.84632 3.81224C7.25709 4.02762 6.39709 4.54455 5.64171 5.77839C5.64171 5.78762 5.1694 6.54762 5.61401 6.95686C5.6294 6.9707 6.02632 7.30301 6.79555 6.81224C6.90632 6.69686 7.60017 6.00147 8.42017 5.92609C8.44136 5.92431 8.4627 5.92695 8.48282 5.93383C8.50295 5.94071 8.52143 5.9517 8.53709 5.96609L12.5694 9.65839C12.5879 9.67532 12.6048 9.69378 12.6217 9.71224C13.0832 9.64147 13.3909 9.21993 13.4802 9.06609L12.0186 5.08301L8.88632 3.83532Z",
    fill: "url(#paint2_linear_133_63768)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0767 3.77749C14.1992 3.77167 13.3288 3.93571 12.5136 4.26057C12.404 4.30755 12.3168 4.39515 12.2703 4.505C12.2239 4.61484 12.2218 4.73841 12.2644 4.8498L13.9767 9.5098C14.0101 9.5997 14.0701 9.67729 14.1487 9.73225C14.2273 9.78721 14.3208 9.81695 14.4167 9.8175H15.3844V3.78519C15.3075 3.78057 15.2013 3.77749 15.0767 3.77749Z",
    fill: "url(#paint3_linear_133_63768)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_133_63768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.06308 3.30797C8.73131 3.1714 8.36058 3.16317 8.02308 3.2849C7.43385 3.50028 6.57385 4.0172 5.81846 5.25105C5.81846 5.26028 5.34616 6.02028 5.79077 6.42951C5.80616 6.44336 6.20308 6.77567 6.97231 6.2849C7.08308 6.16951 7.77693 5.47413 8.59693 5.39874C8.61812 5.39696 8.63945 5.3996 8.65958 5.40649C8.6797 5.41337 8.69818 5.42435 8.71385 5.43874L12.7462 9.13105C12.7646 9.14797 12.7815 9.16643 12.7985 9.1849C13.26 9.11413 13.5677 8.69259 13.6569 8.53874L12.1954 4.55566L9.06308 3.30797Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_133_63768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2539 3.25015C14.3764 3.24432 13.5061 3.40836 12.6909 3.73323C12.5812 3.78021 12.4941 3.8678 12.4476 3.97765C12.4011 4.0875 12.399 4.21107 12.4416 4.32246L14.1539 8.98246C14.1874 9.07235 14.2474 9.14994 14.326 9.20491C14.4046 9.25987 14.498 9.2896 14.5939 9.29015H15.5616V3.25784C15.4847 3.25323 15.3786 3.25015 15.2539 3.25015Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_133_63768",
    x: 3.6001,
    y: 1.19922,
    width: 12.0566,
    height: 9.98438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_133_63768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_133_63768",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_133_63768",
    x: 10.4111,
    y: 1.25,
    width: 7.15039,
    height: 10.0391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_133_63768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_133_63768",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_63768",
    x1: 7.51531,
    y1: 4.44141,
    x2: 7.51531,
    y2: 12.9687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3485FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_133_63768",
    x1: 2.0235,
    y1: 3.03906,
    x2: 2.0235,
    y2: 9.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3485FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_133_63768",
    x1: 9.45175,
    y1: 3.72656,
    x2: 9.45175,
    y2: 9.71224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3485FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_133_63768",
    x1: 13.8091,
    y1: 3.77734,
    x2: 13.8091,
    y2: 9.8175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3485FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.f9faa0c8f1d5b4daff9ab8c801b59736.svg";
export { ForwardRef as ReactComponent };